import { takeLatest, all } from 'redux-saga/effects';
import API from '../Services/Api';

// Types
import { AuthTypes } from '../Redux/AuthRedux';

// Sagas
import { getAuth } from './AuthSagas';

const idpApi = API.create('IDP');

export default function* root() {
	yield all([
        takeLatest(AuthTypes.AUTH_REQUEST, getAuth, idpApi),

    ]);
}